var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "label" }, [_vm._v("Send email")]),
      _c("div", [_vm._v(_vm._s(_vm.sendDummyEmail ? "Dummy" : "Customer's"))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }